'use client';
import React, { useCallback, useEffect, useState } from 'react';

type Props = {
    print?: boolean;
    pageSrc: string;
    afterPrint?: () => void;
};

export default function PagePrint({ print, pageSrc, afterPrint }: Props) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(typeof print === 'boolean' ? print : true);
    }, [print, setVisible]);

    const handlePrint = useCallback(() => {
        setTimeout(() => {
            const id = 'print-frame';
            const iframe = document?.['frames']?.[id] || document.getElementById(id);
            const iframeWindow = iframe.contentWindow || iframe;
            iframe.focus();
            iframeWindow.print();

            setVisible(false);
            if (afterPrint) {
                afterPrint();
            }
        }, 100);
    }, [afterPrint, setVisible]);

    if (!visible) {
        return null;
    }

    return <iframe id="print-frame" style={{ width: 0, height: 0 }} src={pageSrc} onLoad={handlePrint} />;
}
